import { useEffect, useState } from "react";
import Clients from "./Clients";
import Creators from "./Creators";
import JoinUs from "./JoinUs";
import NewExpertise from "./NewExpertise";
import NewHomeHero from "./NewHomeHero";
import NewService from "./NewService";
import NewsInsight from "./NewsInsight";
import NewWhoWeAre from "./NewWhoWeAre";
import Portfolio from "./Portfolio";
import Reviews from "./Reviews";

const NewHomePage = () => {
  const [pageLoading, setPageLoading] = useState(true);
  useEffect(() => {
    // Set Page Title
    document.title =
      "Digital Marketing & IT Services Company | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "TechQilla is a full-service digital marketing & IT solutions company delivering SEO, PPC, web development, SaaS, and branding solutions for growth.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "Digital Marketing & IT Services Company");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute(
      "href",
      "https://www.techqilla.com",
    );
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      setPageLoading(false);
    }, 10); // Simulate page render delay

    return () => clearTimeout(delay);
  }, []);

  if (pageLoading) return null;
  return (
    <div className="pt-[100px] lg:pt-[80px]">
      <NewHomeHero />
      <NewWhoWeAre />
      <NewService />
      <NewExpertise />
      <Portfolio />
      <Reviews />
      <Clients />
      <NewsInsight />
      <JoinUs />
      <Creators />
    </div>
  );
};

export default NewHomePage;
